import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AgentModel } from '@app/shared/models/auth.model';
import { AuthService } from '@app/shared/services/auth.service';

@Component({
    selector: 'app-account-info',
    templateUrl: './account-info.component.html',
    standalone: false
})
export class AccountInfoComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: AgentModel, private authService: AuthService) {}

  public async logout() {
    await this.authService.logout();
  }
}
